import { useMarketplaceLabel, marketplaceSeriesCodes } from "../configurazione/marketplaceDisplay";
import React from "react";
import { LineChart } from '@mui/x-charts/LineChart';

function XmesiYmarketplaces({
    data,
    titolo,
    displayTitolo,
    settings
}) {


    const marketplaceLabel = useMarketplaceLabel();
    let dataset = [];
    const keyToLabel = {};
    for (const key of Object.keys(settings.series).filter(key => settings.series[key])) {
        const metadata = data.series?.find(series => series.key === key);
        keyToLabel[key] = key === 'other' ? 'Other' : marketplaceLabel(metadata?.code || marketplaceSeriesCodes[key], metadata?.label || marketplaceSeriesCodes[key]);
    }

    if (data.dataSet) {
        dataset = data.dataSet;
    }
    console.log("dataset", dataset)

    let mutantValueFormatter = (value) => value

    if (settings.robaDaSommare === 'ordini') {
        mutantValueFormatter = (value) => !value ? 0 : value
    } else if (settings.robaDaSommare === 'importo') {
        mutantValueFormatter = (value) => !value ? 0 : value.toString().replace('.', ',').replace(/\d(?=(?:(?:\d{3})+),)/g, match => `${match}.`) + " €";
    }


    const colors = {
        amz: "#ff9800",
        ebay: "#009688",
        prestashop: "#1565c0",
        storeVS: "#9c27b0",
        storeJS: "#b71c1c",
        cdiscount: "#e91e63",
        eprice: "#8bc34a",
        colizey: "#00bcd4",
        other: "#9e9e9e"
    };

    const xData = dataset.map((row) => new Date(row.year_month_combined))

    const customize = {
        height: 700,
        /* legend: { hidden: true }, */
        margin: { top: 5 },
        stackingOrder: 'descending',
        xAxis: [
            {
                data: xData,
                scaleType: 'time',
                valueFormatter: (v) => v.toLocaleString('it-IT', {
                    year: "2-digit",
                    month: "2-digit",
                })
            }
        ]


    };

    let stackStrategy;

    if (settings.stack) {
        stackStrategy = {
            stack: 'total',
            area: true,
            stackOffset: 'none', // To stack 0 on top of others
            stackOrder: 'reverse'
        };
    }
    

    const series = Object.keys(keyToLabel).map((key) => ({
        dataKey: key,
        label: keyToLabel[key],
        valueFormatter: (v) => mutantValueFormatter(v),
        /* connectNulls: true, */
        color: colors[key],
        showMark: false,
        ...stackStrategy,
    }))



    console.log("series", series)


    if (data) {
        return (
            <div>
                {titolo && displayTitolo && <div className="tc sfondoColChiaro pa2 b">{titolo}</div>}
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
                <div className="pa2 flex flex-wrap items-center">
                    <LineChart
                        series={series}
                        dataset={dataset}
                        {...customize}
                    />
                </div>
            </div>
        )
    } else {
        return (<div>no data</div>)
    }

}

export default XmesiYmarketplaces;